import PageNavbar from "@/components/feature/PageNavbar";
import PageFooter from "@/components/feature/PageFooter";

const SERVICES = [
  { icon: "ri-smartphone-line", title: "Mobile Utilities Development", desc: "End-to-end development of utility apps for iOS and Android — from concept to App Store publishing." },
  { icon: "ri-computer-line", title: "Desktop Application Development", desc: "Native and cross-platform desktop tools for Windows and macOS with peak performance." },
  { icon: "ri-brain-line", title: "AI & Machine Learning Services", desc: "Smart automation, predictive analytics, and AI-powered features embedded into your products." },
  { icon: "ri-line-chart-line", title: "ASO & Store Optimization", desc: "Keyword research, metadata optimization, and A/B testing to maximize organic downloads." },
  { icon: "ri-advertisement-line", title: "User Acquisition & Media Buying", desc: "Data-driven ad campaigns across Meta, Google, TikTok, and programmatic networks." },
  { icon: "ri-customer-service-line", title: "IT Consulting", desc: "Strategic technology advisory, architecture reviews, and process optimization." },
  { icon: "ri-palette-line", title: "UI/UX Design", desc: "Interfaces that convert — wireframing, prototyping, and visual design for digital products." },
  { icon: "ri-shield-check-line", title: "QA & Testing", desc: "Manual and automated testing to ensure bulletproof releases every time." },
];

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-black text-white" style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif" }}>
      <PageNavbar />

      {/* Hero */}
      <section className="relative w-full overflow-hidden" style={{ padding: "80px 16px 50px" }}>
        <div className="mx-auto" style={{ maxWidth: 1440 }}>
          <div style={{ fontSize: 12, color: "#8A8A8A", letterSpacing: 0.5, textTransform: "uppercase", marginBottom: 16 }}>
            What we do
          </div>
          <h1 style={{ fontSize: "clamp(28px, 5vw, 72px)", fontWeight: 700, letterSpacing: "-0.03em", lineHeight: 1.05, color: "#ECECEC", margin: 0, maxWidth: 900 }}>
            One team. Every skill your app needs. From the first wireframe to the millionth download.
          </h1>
          <p style={{ fontSize: "clamp(15px, 1.2vw, 20px)", color: "#8A8A8A", lineHeight: 1.6, marginTop: 20, maxWidth: 720 }}>
            We don't believe in handing you one piece of the puzzle and wishing you luck. Our model combines development, design, testing, and marketing under a single roof — so nothing gets lost in translation and nothing falls through the cracks.
          </p>
        </div>
      </section>

      {/* Full cycle + image */}
      <div className="mx-auto" style={{ maxWidth: 1440, padding: "0 16px" }}>
        <div className="flex flex-col lg:grid gap-10 lg:gap-16" style={{ gridTemplateColumns: "1.05fr 1fr", marginBottom: 60 }}>
          <div>
            <h2 style={{ fontSize: "clamp(24px, 2vw, 32px)", fontWeight: 600, color: "#ECECEC", letterSpacing: "-0.02em", marginBottom: 24 }}>
              How we work — the full picture
            </h2>
            <p style={{ fontSize: 16, color: "#8A8A8A", lineHeight: 1.7, marginBottom: 16 }}>
              <span style={{ color: "#ECECEC", fontWeight: 500 }}>Most agencies drop the ball between development and marketing.</span> We built Intellivex to be the exception. Our process kicks off with deep market research — not just "who are the competitors" but "what are users actually searching for, complaining about, and paying for." That insight feeds directly into both the product roadmap and the promotion playbook.
            </p>
            <p style={{ fontSize: 16, color: "#8A8A8A", lineHeight: 1.7, marginBottom: 16 }}>
              From there, dedicated squads take over. Each project gets a cross-functional unit: a PM running point, engineers writing the stack, designers shaping the experience, and growth specialists already warming up the channels. This isn't a waterfall — it's a tight loop where feedback from one discipline sharpens the others in real time.
            </p>
            <p style={{ fontSize: 16, color: "#8A8A8A", lineHeight: 1.7 }}>
              What you get on your end is simple: transparent timelines, weekly progress demos, and clear ROI metrics the moment campaigns go live. No black boxes, no inflated promises — just a team that treats your product like it's their own and refuses to stop optimizing until the results speak for themselves.
            </p>
          </div>
          <div className="relative w-full lg:w-auto" style={{ minHeight: 280 }}>
            <div className="w-full mx-auto lg:mx-0" style={{ height: 280, maxWidth: 520, borderRadius: 140, overflow: "hidden", background: "#1a1a1a" }}>
              <img
                src="https://storage.readdy-site.link/project_files/c0e0600e-4e78-44ef-81fe-aa0be702df4c/5d0feb44-1961-42d8-b336-3150f200f0b9_compressed_ChatGPT-Image-13-.-2026-.-13_46_55.webp"
                alt="Intellivex team"
                className="w-full h-full"
                style={{ objectFit: "cover", objectPosition: "top" }}
              />
            </div>
          </div>
        </div>

        {/* Services grid */}
        <div style={{ marginBottom: 80 }}>
          <div style={{ fontSize: 12, color: "#8A8A8A", letterSpacing: 0.5, textTransform: "uppercase", marginBottom: 30 }}>
            Services
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-5">
            {SERVICES.map((s) => (
              <div
                key={s.title}
                className="hover:border-[rgba(147,197,253,0.3)] hover:bg-[rgba(147,197,253,0.04)]"
                style={{ border: "1px solid rgba(255,255,255,0.08)", borderRadius: 16, padding: 32, background: "rgba(255,255,255,0.02)", transition: "border-color 0.3s ease, background 0.3s ease" }}
              >
                <div style={{ width: 44, height: 44, borderRadius: 12, background: "rgba(147,197,253,0.15)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 18 }}>
                  <i className={s.icon} style={{ fontSize: 22, color: "#93C5FD" }} />
                </div>
                <h3 style={{ fontSize: 18, fontWeight: 600, color: "#ECECEC", marginBottom: 10 }}>{s.title}</h3>
                <p style={{ fontSize: 14, color: "#8A8A8A", lineHeight: 1.6 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <PageFooter />
    </div>
  );
}